'use strict';

/**
 * Module to manage the login motivation pop-in/tooltip.
 * Displays a pop-in under the "My Account" icon to encourage non-logged users to sign in.
 */
module.exports = function () {
    const POPIN_DISPLAY_DELAY = 10000;
    const POPIN_DISMISSED_KEY = 'motivationPopinDismissed';

    // URL patterns where the pop-in should NOT appear
    const EXCLUDED_URL_PATTERNS = [
        'Login-Show',
        'recrutement-club',
        '/cart',
        'Cart-Show',
        '/Checkout-Begin',
        'Checkout-Login'
    ];

    /**
     * Checks if the user has already dismissed the pop-in (clicked the close button).
     * @returns {boolean} - true if the pop-in has been dismissed
     */
    function hasPopinBeenDismissed() {
        try {
            return sessionStorage.getItem(POPIN_DISMISSED_KEY) === 'true';
        } catch (e) {
            return false;
        }
    }

    /**
     * Marks the pop-in as dismissed in sessionStorage.
     */
    function markPopinAsDismissed() {
        try {
            sessionStorage.setItem(POPIN_DISMISSED_KEY, 'true');
        } catch (e) {
            // ignore
        }
    }

    /**
     * Checks if the user is currently logged in via the DOM.
     * @returns {boolean} - true if the user is logged in
     */
    function isUserLoggedIn() {
        const userMessage = document.querySelector('.user-message');
        if (userMessage) {
            return userMessage.getAttribute('data-isloggedin') === 'true';
        }
        return false;
    }

    /**
     * Checks if the current page URL matches any excluded pattern.
     * @returns {boolean} - true if the page is excluded
     */
    function isExcludedPage() {
        return EXCLUDED_URL_PATTERNS.some(function (pattern) {
            return window.location.href.indexOf(pattern) !== -1;
        });
    }

    /**
     * Checks for specific CSS selectors that should prevent the pop-in from showing.
     * @returns {boolean} - true if forbidden selectors are present
     */
    function hasForbiddenSelectors() {
        if (document.querySelector('#FollowAnalytics-added-CSS')) {
            return true;
        }

        if (document.querySelector('.icon-ico_mon-compte_log')) {
            return true;
        }

        return false;
    }

    /**
     * Checks if the user is browsing via the Mobile App (Native or PWA).
     * @returns {boolean} true if it's the app, false if it's mobile web (Safari/Chrome)
     */
    function isMobileApp() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isNativeApp = /OrchestraApp|FABUILD-IOS-APP|FABUILD-ANDROID-APP/i.test(userAgent);

        return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true || isNativeApp;
    }

    /**
     * Shows the animated red dot on the account icon.
     */
    function showDot() {
        const dot = document.querySelector('.dotMenu');
        if (dot) {
            dot.classList.add('dotShow');
        }
    }

    /**
     * Shows the motivation pop-in.
     */
    function showPopin() {
        const popin = document.querySelector('.account-motivation-popin');
        if (popin) {
            popin.classList.add('active');
        }
    }

    /**
     * Dismisses the pop-in permanently for the session.
     */
    function dismissPopin() {
        const popin = document.querySelector('.account-motivation-popin');
        if (popin) {
            popin.classList.remove('active');
            popin.classList.add('hidden');
            markPopinAsDismissed();
            showDot();
            setTimeout(function () {
                popin.style.display = 'none';
            }, 500);
        }
    }

    /**
     * Initializes event listeners.
     */
    function initEventListeners() {
        const closeButton = document.querySelector('.account-motivation-popin-close');

        if (closeButton) {
            closeButton.addEventListener('click', function (e) {
                e.stopPropagation();
                dismissPopin();
            });
        }
    }

    /**
     * Main initialization function.
     */
    function init() {
        if (isMobileApp() || isUserLoggedIn() || isExcludedPage() || hasForbiddenSelectors()) {
            return;
        }

        const popin = document.querySelector('.account-motivation-popin');
        if (!popin) {
            return;
        }

        initEventListeners();

        showDot();

        if (!hasPopinBeenDismissed()) {
            setTimeout(function () {
                if (!hasPopinBeenDismissed()) {
                    showPopin();
                }
            }, POPIN_DISPLAY_DELAY);
        }
    }

    // Run initialization when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
};
